import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useAuth } from 'react-oidc-context';
import { IWarehouse } from './types';

export function usePutWarehouseMutation(warehouseId?: string) {
  const auth = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (warehouse: Omit<IWarehouse, 'id'> | IWarehouse) =>
      fetch(`/api/warehouse`, {
        method: 'PUT',
        body: JSON.stringify(warehouse),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.user?.id_token}`,
        },
      }).then((res) =>
        res.json() as Promise<IWarehouse>,
      ),
    mutationKey: ['putWarehouse', warehouseId],
    onSuccess: () => {
      if (!warehouseId) {
        queryClient.invalidateQueries({ queryKey: ['warehouses'] });
      }
      queryClient.invalidateQueries({ queryKey: ['warehouse', warehouseId] });
    }
  });
}